import { createFileRoute } from '@tanstack/react-router';

import { grantListDeps, loadGrantList } from '../features/grants/list-loader';
import { GrantTypePage, grantTypeHead } from '../features/grants/type-page';
import { grantTypeSearch } from '../features/grants/type-search';

/**
 * `/news/grants` — 자금·바우처 전용 목록. 옛 `/grants` · `/subsidies` · `/vouchers` 는 서버가 301 로 여기로 보낸다.
 *
 * 화면은 `GrantTypePage` 하나를 넷이 나눠 쓴다. 네 벌로 만들면 한쪽만
 * 고쳐지고, 그때부터 유형마다 다르게 동작하는 목록이 된다.
 */
export const Route = createFileRoute('/news/grants')({
  validateSearch: grantTypeSearch,
  loaderDeps: ({ search }) => grantListDeps(search),
  loader: ({ context, deps }) => loadGrantList(context, deps, { support: 'grant' }),
  head: () => grantTypeHead('grant', '/news/grants'),
  component: () => (
    <GrantTypePage type="grant" path="/news/grants" filters={Route.useLoaderDeps()} loaded={Route.useLoaderData()} />
  ),
});
